import { Component, Input, OnInit } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';

@Component({
  selector: 'app-modal-view-boolean-prop',
  templateUrl: './modal-view-boolean-prop.component.html',
  styleUrls: ['./modal-view-boolean-prop.component.scss']
})
export class ModalViewBooleanPropComponent implements OnInit {
  @Input({required: true}) controllers: Controller[];
  @Input({required: true}) propFilterFunction: (property: Property) => boolean
  @Input({required: true}) activeSufix: string;
  @Input({required: true}) inactiveSufix: string;
  @Input({required: true}) iconActive: string;
  @Input({required: true}) iconInactive: string;
  @Input({required: true}) forcePropIndex: number;

  constructor() { }

  ngOnInit(): void {
    this.activeSufix = 'active';
    this.inactiveSufix = 'inactive';

  }

}
